import { linkButton } from './link-button.css';
import type { LinkButtonVariants } from './link-button.css';
import { legacyLinkButtonOverride } from './link-button-legacy.css';
import type { IconName } from '@customerio/pluma-icons';
import type { IconVariants } from '../icon/icon.css';
import clsx from 'clsx';

export const linkButtonProps = new Set([
	'variant',
	'isError',
	'icon',
	'iconSize',
	'iconPosition',
	'iconAlignment',
	'isDisabled',
	'unsafe_isLegacy',
]);

export interface BaseLinkButtonProps {
	variant?: 'primary' | 'secondary';
	isError?: boolean;
	icon?: IconName;
	iconSize?: IconVariants['size'];
	iconPosition?: 'leading' | 'trailing';
	iconAlignment?: 'uppercase' | 'lowercase';
	isDisabled?: boolean;
	unsafe_isLegacy?: boolean;
}

export function linkButtonClassName(props: Partial<BaseLinkButtonProps>) {
	let variant: LinkButtonVariants['variant'] = props.variant ?? 'primary';

	if (props.isError) {
		variant = 'critical';
	}

	const classes = [linkButton({ variant })];

	if (props.unsafe_isLegacy === true) {
		classes.push(legacyLinkButtonOverride);
	}

	return clsx(classes);
}
